"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsivePropNames = void 0;
const responsivePropNames = propName => [propName, `${propName}FromS`, `${propName}FromM`, `${propName}FromL`, `${propName}FromXL`];
exports.responsivePropNames = responsivePropNames;